import api from './client';

/**
 * The settings keys the admin console edits.
 *
 * The backend stores and returns more than this (platform name, commission
 * rates, fee amounts, user-management flags, notification toggles, currency,
 * timezone — see setting.controller.js). Those are no longer exposed in the UI, so they
 * are intentionally absent here; GET responses simply carry extra keys that
 * the Settings page ignores and never writes back.
 */
export interface PlatformSettings {
  supportEmail: string;
}

interface SettingsResponse {
  status: number;
  message?: string;
  settings: PlatformSettings;
}

/** GET /api/settings */
export const getSettings = async (): Promise<PlatformSettings> => {
  const res = await api.get<SettingsResponse>('/settings');
  return res.data.settings;
};

/**
 * PUT /api/settings
 * Accepts a partial map. The backend upserts each key independently and
 * returns the full updated settings object.
 */
export const updateSettings = async (
  partial: Partial<PlatformSettings>
): Promise<PlatformSettings> => {
  const res = await api.put<SettingsResponse>('/settings', partial);
  return res.data.settings;
};
